import Swiper, { Pagination, Navigation } from 'swiper';

export default function gallery() {

  Swiper.use([Pagination, Navigation]);

   /* Frontpagae */
  new Swiper('[data-gallery-home]', {
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 10,
    initialSlide: 1,
    speed: 1000,
    loop: true,
    centeredSlides: true,
    observer: true,
    autoHeight: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
    },
  });


  /* Single project */
  new Swiper('[data-single-gallery]', {
    effect: 'slide',
    slidesPerView: 1,
    initialSlide: 1,
    speed: 1000,
    loop: false,
    observer: true,
    autoHeight: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  if($('.single-gallery .swiper-container .swiper-slide').length == 1) {
    $('.swiper-wrapper').addClass( 'disabled' );
    $('.swiper-pagination').addClass( 'disabled' );
 }

}



// WEBPACK FOOTER //
// ./scripts/modules/gallery.js